@if (isActive) {
  <!-- Treat the case when the chip is set as active -->
  <div class="chip-container chip-active">
    @if (icon !== '') {
      <i class="pi {{ icon }}"></i>
    }
    <span>{{ label }}</span>
    @if (badge) {
      <p-badge [value]="badge"></p-badge>
    }
  </div>
} @else {
  <!-- Treat the case for a classic chip -->
  <div class="chip-container">
    @if (icon !== '') {
      <i class="pi {{ icon }}"></i>
    }
    <span class="text-height">{{ label }}</span>
    @if (badge) {
      <p-badge [value]="badge"></p-badge>
    }
    @else if (isLoading) {
      <p-progressSpinner class="small-spinner"/>
    }
  </div>
}
